export class GetIngestionPipelineSpendLedgerResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<IngestionPipelineSpendLedgerRow>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetIngestionPipelineSpendLedgerResponse.attributeTypeMap;
    }
    constructor() {
    }
}
